import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
import { SaveService } from '../services/save.service';
import { RootState } from '../store/root.state';
import { IApplicationContent } from '../types/content.type';
import { PlaceholderPipe } from '../pipes/placeholder.pipe';
import { TrimValueDirective } from '../directives/trim-value.directive';
import { NgIf } from '@angular/common';

const getParams = (query) => {
	if (!query) {
		return {};
	}

	return (/^[?]/.test(query) ? query.slice(1) : query).split('&').reduce((params, param) => {
		const [key, value] = param.split('=');
		params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
		return params;
	}, {});
};

@Component({
    selector: 'app-how-heard',
    templateUrl: './how-heard.component.html',
    styleUrls: ['./how-heard.component.scss'],
    imports: [NgIf, FormsModule, ReactiveFormsModule, TrimValueDirective, PlaceholderPipe]
})
export class HowHeardComponent implements OnInit {
	@Input() applicationEmail: string;

	schoolID: number = window['nha-sa-schoolId'] || null;
	culture: string = window['nha-sa-culture'] || 'en-US';
	appContent: IApplicationContent;
	howHeardForm: UntypedFormGroup;
	isSaving = false;
	howHeardSuccess = false;
	howHeardError = false;

	constructor(
		private fb: UntypedFormBuilder,
		private saveService: SaveService,
		private store: Store
	) {}

	ngOnInit(): void {
		this.createForm();

		this.store.select(RootState.content).subscribe((content) => {
			if (content && content.stateCode) {
				this.appContent = content;
				this.howHeardForm.controls.schoolName.setValue(content.schoolName);

				if (!this.applicationEmail) {
					const params = getParams(window.location.search);
					const email = params['email'] || '';
					this.howHeardForm.controls.email.setValue(email);
				}
			}
		});
	}

	createForm(): void {
		this.howHeardForm = this.fb.group({
			email: [
				this.applicationEmail,
				[Validators.required, Validators.pattern('(^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$)'), Validators.maxLength(254)]
			],
			response: ['', [Validators.required, Validators.maxLength(500)]],
			schoolName: ''
		});
	}

	getControl(controlName: string): UntypedFormControl {
		return this.howHeardForm.get(controlName) as UntypedFormControl;
	}

	goToHomepage(): void {
		window.location.href = window.location.href.split('/apply')[0];
	}

	submitHowHeard(): void {
		this.howHeardForm.get('email').markAsTouched();
		this.howHeardForm.get('response').markAsTouched();

		if (this.howHeardForm.valid) {
			this.isSaving = true;

			this.saveService.saveHowHeard(this.howHeardForm.value).subscribe(
				(data) => {
					this.isSaving = false;
					this.howHeardSuccess = true;
				},
				(err) => {
					this.isSaving = false;
					this.howHeardError = true;
				}
			);
		}
	}
}
